import httpHelper from "@/helpers/httpHelper";

const supportService = {
    async index() {
        return await httpHelper.get("/WebApi/Support/Index");
    }
};

export default supportService;